/* parallax component
==================================================== */
gsap.to(".c-parallax__image", {
  "--c-parallax-y": "100%",
  scrollTrigger: {
    trigger: ".c-parallax__image",
    start: "top bottom",
    end: "bottom top",
    scrub: true,
  },
});
